const SEASON_ORDER = {
    SP: 1,
    SU: 2,
    FA: 3,
    HO: 4
};
/**
 * Sorts an array of seasons in chronological order.
 *
 * Seasons are sorted by year first, then by season code within the year.
 * Season order within a year: Spring (SP) → Summer (SU) → Fall (FA) → Holiday (HO)
 * Invalid season IDs (non-standard format or unrecognized codes) are sorted to the end.
 *
 * @param seasons - Array of season reference objects with id and label
 * @returns New array of seasons sorted chronologically
 *
 * @example
 * ```typescript
 * const seasons = [
 *   { id: 'ho27', label: 'Holiday 2027' },
 *   { id: 'sp27', label: 'Spring 2027' },
 *   { id: 'fa27', label: 'Fall 2027' }
 * ]
 * const sorted = sortSeasons(seasons)
 * // Returns: [Spring 2027, Fall 2027, Holiday 2027]
 * ```
 */
export function sortSeasons(seasons) {
    return [...seasons].sort((a, b) => {
        if (!a.id || typeof a.id !== 'string')
            return 1;
        if (!b.id || typeof b.id !== 'string')
            return -1;
        const codeA = a.id.toUpperCase().substring(0, 2);
        const codeB = b.id.toUpperCase().substring(0, 2);
        const yearA = parseInt(a.id.substring(2, 4), 10);
        const yearB = parseInt(b.id.substring(2, 4), 10);
        const isValidA = !isNaN(yearA) && SEASON_ORDER[codeA] !== undefined;
        const isValidB = !isNaN(yearB) && SEASON_ORDER[codeB] !== undefined;
        if (!isValidA && !isValidB)
            return 0;
        if (!isValidA)
            return 1;
        if (!isValidB)
            return -1;
        if (yearA !== yearB)
            return yearA - yearB;
        return SEASON_ORDER[codeA] - SEASON_ORDER[codeB];
    });
}
